module.exports = __webpack_public_path__ + "static/media/ticksTwo063fa933.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/therapist/images/ticksTwo.svg
// module id = 1496
// module chunks = 0